<template>
  <div class="bubble-skeleton">
    <SkeletonHeader />
    <div class="bubble-skeleton__container">
      <div class="position-ball-main">
        <span class="skeleton-box ball-main" />

        <div class="position-top-right">
          <span class="skeleton-box ball-small-top-right" />
        </div>

        <div class="position-middle-right">
          <span class="skeleton-box ball-middle-right" />
        </div>

        <div class="position-bottom-middle">
          <span class="skeleton-box ball-bottom-middle" />
        </div>

        <div class="position-top-left">
          <span class="skeleton-box ball-top-left" />
        </div>

        <div class="position-middle-left">
          <span class="skeleton-box ball-middle-left" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SkeletonHeader } from '@/components/base';

export default {
  name: 'BubbleSkeleton',
  components: {
    SkeletonHeader,
  },
};
</script>

<style lang="scss" scoped>
.bubble-skeleton {
  &__container {
    width: 100%;
    height: 570px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .skeleton-box {
    display: inline-block;
    height: 1em;
    position: relative;
    overflow: hidden;
    background: linear-gradient(270deg, #fafafa 0%, #d2d2d4 100%);
    border-radius: 50%;

    &::after {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      transform: translateX(-100%);
      background-image:
        linear-gradient(
          90deg,
          rgba(#fff, 0) 0,
          rgba(#fff, 0.2) 20%,
          rgba(#fff, 0.5) 60%,
          rgba(#fff, 0)
        );
      animation: shimmer 1.5s infinite;
      content: '';
    }

    @keyframes shimmer {
      100% {
        transform: translateX(100%);
      }
    }
  }

  .position-ball-main {
    position: relative;
  }

  .ball-main {
    width: 200px;
    height: 200px;
  }

  .position-top-right {
    position: absolute;
    top: 0;
    right: -30px;
    transform: translateY(-100%);
  }

  .ball-small-top-right {
    width: 83px;
    height: 83px;
  }

  .position-middle-right {
    position: absolute;
    top: 0;
    right: -30px;
    transform: translate(100%, -20%);
  }

  .ball-middle-right {
    width: 117px;
    height: 117px;
  }

  .position-bottom-middle {
    position: absolute;
    bottom: -10px;
    left: -10px;
    transform: translateY(100%);
  }

  .ball-bottom-middle {
    width: 83px;
    height: 83px;
  }

  .position-top-left {
    position: absolute;
    top: -20px;
    left: -40px;
    transform: translateX(-100%);
  }

  .ball-top-left {
    width: 32px;
    height: 32px;
  }

  .position-middle-left {
    position: absolute;
    top: 0;
    left: -40px;
    transform: translate(-100%, 33%);
  }

  .ball-middle-left {
    width: 160px;
    height: 160px;
  }
}
</style>
